import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'



//import useRadio from "../Assets/UseRadio";
import useInput from "../Assets/UseInput";
import {Trans, useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";


var serialize = require('serialize-javascript');

function Remark (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const [Age, setAge]= useState(localStorage.getItem("Age"))
    const nextLocation = {
        pathname: '../final',
        state: { d: d }
    }
    const handleNext = (e) =>{
        e.preventDefault()
        history(nextLocation)
    }

    const prevLocation = {
        pathname: '../consequences',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }

    // set control value and name to classic Inputs using the custom Hook useInput
    const {value: Field0602Firstname, bind: bindField0602Firstname, reset: setField0602Firstname} = useInput('')
    const {value: Field0601Name, bind: bindField0601Name, reset: setField0601Name} = useInput('')
    const {value: Field61Remark, bind: bindField61Remark, reset: setField61Remark} = useInput('')
    const {value: Field0603AddressStreet, bind: bindField0603AddressStreet, reset: setField0603AddressStreet} = useInput('')
    const {value: Field0603AddressStreetNumber, bind: bindField0603AddressStreetNumber, reset: setField0603AddressStreetNumber} = useInput('')
    const {value: Field0603AddressStreetBox, bind: bindField0603AddressStreetBox, reset: setField0603AddressStreetBox} = useInput('')
    const {value: Field0603AddressZip, bind: bindField0603AddressZip, reset: setField0603AddressZip} = useInput('')
    const {value: Field0603AddressTown, bind: bindField0603AddressTown, reset: setField0603AddressTown} = useInput('')
    const {value: Field0604Phone, bind: bindField0604Phone, reset: setField0604Phone} = useInput('')
    const {value: Field0605GSM, bind: bindField0605GSM, reset: setField0605GSM} = useInput('')
    const {value: Field0606Email, bind: bindField0606Email, reset: setField0606Email} = useInput('')
    const {value: Field0607Link, bind: bindField0607Link, reset: setField0607Link} = useInput('')
    const {value: Field0608Signatory, bind: bindField0608Signatory, reset: setField0608Signatory} = useInput('')


    const [FieldTiercePersonne, setFieldTiercePersonne] = useState("");
    const [Field61HasRemark, setField61HasRemark] = useState("");


// FieldTiercePersonne Input custom handleChange
    const handleChangeFieldTiercePersonne = (e) => {
        let value = e.target.value
        setFieldTiercePersonne(value);
    }

    // Field61HasRemark Input custom handleChange
    const handleChangeField61HasRemark = (e) => {
        let value = e.target.value
        setField61HasRemark(value);
    }

    const [FieldLegalConsent, setFieldLegalConsent] = useState(false);
    //  Input radio change
    const handleChangeFieldLegalConsent = (e) => {
        let value = e.target.value
        setFieldLegalConsent(!FieldLegalConsent);
    }



    const [stored, setStored] =  useState("")

    useEffect(() => {
                    window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            //const dead = "true"
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            setIsLoading(false);

            const remark = JSON.parse(localStorage.getItem('remark'))

            if (remark){
                setStored(true)
                setField0602Firstname(remark.Field0602Firstname)
                setField0601Name(remark.Field0601Name)
                setField0603AddressStreet(remark.Field0603AddressStreet)
                setField0603AddressStreetNumber(remark.Field0603AddressStreetNumber)
                setField0603AddressStreetBox(remark.Field0603AddressStreetBox)
                setField0603AddressZip(remark.Field0603AddressZip)
                setField0603AddressTown(remark.Field0603AddressTown)
                setField0604Phone(remark.Field0604Phone)
                setField0605GSM(remark.Field0605GSM)
                setField0606Email(remark.Field0606Email)
                setField0607Link(remark.Field0607Link)
                setField0608Signatory(remark.Field0608Signatory)
                setFieldTiercePersonne(remark.FieldTiercePersonne)
                setField61HasRemark(remark.Field61HasRemark)
                setField61Remark(remark.Field61Remark)
            }
        };
        fetchData()
    }, []);




    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();

        let notValid = true
        // required empty fields
        if (d){
            notValid =
                !FieldLegalConsent ||
                !Field0602Firstname ||
                !Field0601Name ||
                !Field0603AddressStreet ||
                !Field0603AddressStreetNumber ||
                !Field0603AddressZip ||
                !Field0603AddressTown ||
                !Field61HasRemark ||
                !Field0607Link

        }else{
            notValid = !FieldTiercePersonne ||
                !FieldLegalConsent ||
                ((FieldTiercePersonne ==="no" && !Field0602Firstname )||
                    (FieldTiercePersonne ==="no" && !Field0601Name )||
                    (FieldTiercePersonne ==="no" && !Field0603AddressStreet )||
                    (FieldTiercePersonne ==="no" && !Field0603AddressStreetNumber )||
                    (FieldTiercePersonne ==="no" && !Field0603AddressZip )||
                    (FieldTiercePersonne ==="no" && !Field0603AddressTown )||
                    (FieldTiercePersonne ==="no" && !Field61HasRemark )||
                    (FieldTiercePersonne ==="no" && !Field0607Link)||
                    (FieldTiercePersonne ==="no" && !Field0608Signatory))
        }

      //console.log( )
        setNotValid(notValid)
        if (!notValid){
            let remark = {
                Field0602Firstname: Field0602Firstname,
                Field0601Name: Field0601Name,
                Field61Remark: Field61Remark,
                Field0603AddressStreet: Field0603AddressStreet,
                Field0603AddressStreetNumber: Field0603AddressStreetNumber,
                Field0603AddressStreetBox: Field0603AddressStreetBox,
                Field0603AddressZip: Field0603AddressZip,
                Field0603AddressTown: Field0603AddressTown,
                Field0604Phone: Field0604Phone,
                Field0605GSM: Field0605GSM,
                Field0606Email: Field0606Email,
                FieldTiercePersonne: FieldTiercePersonne,
                Field61HasRemark: Field61HasRemark,
                Field0607Link:Field0607Link,
                Field0608Signatory:Field0608Signatory

            }
            //let stringInfo = JSON.stringify(remark)
            let stringInfo = serialize(remark, {isJSON: true});
            localStorage.setItem("remark" , stringInfo)
            //console.log(JSON.parse(stringInfo))
            history(nextLocation)
        }

    }



    const { i18n } = useTranslation();
    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
                    {(Age < 16)?
                        <BreadCrumb n={7}/>:<BreadCrumb n={8}/>}
                    <Row>
                        <Col>


                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <h3>{i18n.t("Remarques")}</h3>
                                <div className="formlevel01">
                                    {!d &&
                                    <div>
                                        <FormGroup>
                                            <Label for="FieldTiercePersonne" className={(NotValid && FieldTiercePersonne === "") ? "text-danger" : "text"}>{i18n.t("ISVICTICM")} <span className={"text-danger"}>*</span></Label>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="FieldTiercePersonne" onChange={handleChangeFieldTiercePersonne} value="no" checked={FieldTiercePersonne === "no"}/>
                                                    &nbsp;{  i18n.t("NO")}
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="FieldTiercePersonne" onChange={handleChangeFieldTiercePersonne} value="yes" checked={FieldTiercePersonne === "yes"}/>
                                                    &nbsp;{  i18n.t("YES")}
                                                </Label>
                                            </div>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>
                                    </div>
                                    }

                                    { (d || FieldTiercePersonne === "no") &&
                                    <div >
                                        <h4>{i18n.t("Données de la personne signataire")}</h4>
                                        <FormGroup>
                                            <Label for="Field0602Firstname">{i18n.t("FIRSTNAMEDATA")} <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} {...bindField0602Firstname} placeholder={i18n.t("PLACEHOLDERFIRSTNAMEDATA")} invalid={(NotValid && Field0602Firstname === "")}/>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="Field0601Name">{ i18n.t("NAMEDATA")} <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} {...bindField0601Name} placeholder={i18n.t("PLACEHOLDERNAMEDATA")} invalid={(NotValid && Field0601Name === "")}/>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>

                                        <div>
                                            <Label for="Field0603Address">{i18n.t("ADDRESSDATA")}</Label>
                                            <FormGroup className="row py-0">
                                                <Label for="Field0603AddressStreet" className={"col-sm-2"}>{i18n.t("field0603AddressStreet")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField0603AddressStreet} placeholder={i18n.t("field0603AddressStreet")} invalid={(NotValid && Field0603AddressStreet === "")? true : undefined}/>
                                            </FormGroup>
                                            <FormGroup className="row py-0">
                                                <Label for="Field0603AddressStreetNumber" className={"col-sm-2"} invalid={(NotValid && Field0603AddressStreetNumber === "")? true : undefined}>{i18n.t("field0603AddressStreetNumber")} <span className={"text-danger"}>*</span></Label>

                                                <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField0603AddressStreetNumber} placeholder={i18n.t("field0603AddressStreetNumber")} invalid={(NotValid && Field0603AddressStreetNumber === "")? true : undefined}/>

                                                <Label  for="Field0603AddressStreetBox" className={"col-sm-2"} >{i18n.t("field0603AddressStreetBox")}</Label>

                                                <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField0603AddressStreetBox} placeholder={i18n.t("field0603AddressStreetBox")} />

                                            </FormGroup>
                                            <FormGroup className="row  py-0">
                                                <Label for="Field0603AddressZip" className={"col-sm-2"} invalid={(NotValid && Field0603AddressZip === "") ? true : undefined}>{i18n.t("field0603AddressZip")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField0603AddressZip} placeholder={i18n.t("field0603AddressZip")} invalid={(NotValid && Field0603AddressZip === "")? true : undefined}/>

                                            </FormGroup>
                                            <FormGroup className="row  py-0">
                                                <Label for="Field0603AddressTown" className={"col-sm-2"} invalid={(NotValid && Field0603AddressTown === "")? true : undefined}>{i18n.t("field0603AddressTown")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField0603AddressTown} placeholder={i18n.t("field0603AddressTown")} invalid={(NotValid && Field0603AddressTown === "")? true : undefined}/>
                                            </FormGroup>
                                        </div>

                                        <FormGroup>
                                            <Label for="Field0607Link" invalid={(NotValid && Field0607Link === "")? true : undefined}>{d? i18n.t("Lien de la personne signataire avec le défunt") : i18n.t("Lien de la personne signataire avec la victime")} <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} {...bindField0607Link}
                                                   placeholder={d? i18n.t("Indiquer le lien de la personne signataire avec le défunt"): i18n.t("Indiquez le lien de la personne signataire avec la victime")} invalid={(NotValid && Field0607Link === "")}/>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>

                                        {!d && FieldTiercePersonne === "no" &&
                                        <FormGroup>
                                            <Label for="Field0608Signatory" invalid={(NotValid && Field0608Signatory === "")}>{i18n.t("finalText04")} <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} {...bindField0608Signatory}
                                                   placeholder={i18n.t("PlaceholderfinalText04")} invalid={(NotValid && Field0608Signatory === "")}/>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>
                                        }
                                        <div>
                                            <FormGroup>
                                                <Label for="Field0604Phone">{i18n.t("PHONEDATA")}</Label>
                                                <Input type="text" maxLength={500} {...bindField0604Phone}
                                                       placeholder={i18n.t("PLACEHOLDERPHONEDATA")}/>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field0605GSM">{i18n.t("GSMDATA")}</Label>
                                                <Input type="text" maxLength={500} {...bindField0605GSM}
                                                       placeholder={i18n.t("PLACEHOLDERGSMDATA")} invalid={(NotValid && Field0605GSM === "true")}/>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field0606Email">{i18n.t("EMAILDATA")}</Label>
                                                <Input type="text" maxLength={500} {...bindField0606Email}
                                                       placeholder={i18n.t("PLACEHOLDEREMAILDATA")}/>
                                                <div className="alert alert-warning mt-2">
                                                    <button type="button" className="close" data-dismiss="alert"
                                                            aria-hidden="true">×
                                                    </button>
                                                    <FontAwesomeIcon className="pre" icon={['fas', 'info-circle']} />&nbsp;
                                                    <strong>{i18n.t("Attention")}</strong>
                                                    <hr className="message-inner-separator"/>
                                                    <p>{i18n.t("EmailWarning")}</p>
                                                </div>
                                            </FormGroup>

                                        </div>
                                    </div>
                                    }
                                    <FormGroup >
                                        <Label for="Field61HasRemark" className={(NotValid && Field61HasRemark === "") ? "text-danger" : "text"}>{ i18n.t("field61HasRemark")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio"  onChange={handleChangeField61HasRemark}  name="Field61HasRemark" value="no" checked={Field61HasRemark === "no"}/>
                                                &nbsp;{i18n.t("NO")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" onChange={handleChangeField61HasRemark} name="Field61HasRemark" value="yes" checked={Field61HasRemark === "yes"}/>
                                                &nbsp;{i18n.t("YES")}
                                            </Label>
                                        </div>
                                        {Field61HasRemark === "yes" &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field61Remark">{i18n.t("field61Remark")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="textarea" maxLength={5000} {...bindField61Remark} rows={6} placeholder={i18n.t("placeholderfield61Remark")} invalid={(NotValid && Field61Remark === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>}
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <Alert color={"warning"}>
                                        <Trans i18nKey={d? "finalText01Death" : "finalText01"}>
                                            <p>Les données à caractère personnel recueillies au moyen du présent document sont traitées par les assureurs destinataires de ce document, responsables de leurs traitements, en vue des finalités suivantes : la gestion des sinistres repris sous rubrique, en particulier la constatation et l’évaluation du dommage encouru à la suite du décès du proche du soussigné; la détection et la prévention de la fraude, le traitement à des fins statistiques.</p><p>A ces seules fins, les données peuvent être, si nécessaire, communiquées à d’autres entreprises d’assurances concernées par l’indemnisation du dommage encouru à la suite du décès du proche du soussigné, à leurs représentants en Belgique, à leurs correspondants à l’étranger, à leurs réassureurs, à leurs bureaux de règlement de sinistres, à un expert, à un avocat, à un conseil technique, à l’intermédiaire d’assurances du soussigné ou de son proche décédé et, plus généralement, à toute personne ou entité qui exerce un recours ou contre qui un recours est exercé en relation avec le dommage visé ci-avant.</p><p>La base juridique du traitement de données est constituée par les contrats d’assurance (Protection juridique (PJ), Responsabilité civile (RC) ou tout autre contrat) ainsi que par l’obligation qui découle du contrat RC pour l’assureur responsable du traitement d’indemniser, le cas échéant, les victimes de dommages encouru à la suite du décès du proche ou des sinistres repris sous rubrique. Dans l’hypothèse où le présent questionnaire ne serait pas rempli de manière adéquate, l’assureur se trouverait dans l’impossibilité de donner une suite à la présente demande d'intervention. Le traitement se fonde en outre sur l’intérêt légitime de l’assureur de prévenir la fraude à l’assurance et d’élaborer des statistiques.</p><p>Les données traitées sont conservées par l’assureur responsable pendant la durée de la gestion du sinistre, qui sera adaptée chaque fois que les circonstances l’exigent. Cette durée sera prolongée par le délai de prescription afin que l’assureur puisse faire face aux éventuels recours qui seraient engagés après la clôture du dossier sinistre.</p><p>Lesdites données sont traitées avec la plus grande discrétion et uniquement par les personnes habilitées à le faire.</p><p>Les personnes concernées peuvent prendre connaissance des données et, le cas échéant, les faire rectifier au moyen d’une demande datée et signée accompagnée d’une photocopie recto verso de la carte d’identité, adressée à l’assureur destinataire du présent document. Lesdites personnes peuvent en outre, selon les mêmes modalités, et dans les limites prévues par le Règlement général sur la protection des données, s’opposer au traitement de données ou demander la limitation de celui-ci. Elles peuvent aussi demander l’effacement ou la portabilité des données les concernant.</p><p>De plus amples informations et notamment les coordonnées du délégué à la protection des données peuvent être obtenues auprès de ce même assureur.</p><p>Une réclamation peut le cas échéant être introduite auprès de l’Autorité de Protection des données.</p><p> Dans le cadre de la procédure d’indemnisation, l’assureur à l’obligation de respecter « les règles de conduite pour règlement de sinistre : relations avec les victimes d’accidents graves » qui se trouvent sur le site web www.assuralia.be. Toute plainte relative à la bonne application par l’entreprise d’assurances de ce code de conduite est adressée par la victime du dommage encouru à la suite du décès du proche au service des plaintes de l’entreprise concernée, conformément aux règles de conduite pour la gestion des réclamations dans les entreprises d’assurances (disponibles sur <a href='//www.assuralia.be' target='_blank'>www.assuralia.be</a>). Si la réponse donnée par ce service n’est pas satisfaisante pour la victime, celle-ci peut introduire sa plainte auprès de l’Ombudsman des assurances via le site <a href='//www.ombudsman-insurance.be' target='_blank' rel='noopener noreferrer'>www.ombudsman-insurance.be</a>.</p>
                                        </Trans>
                                    </Alert>
                                    <div className="checkbox">
                                        <Label className={NotValid && !FieldLegalConsent ? "text-danger": "text"}>
                                            <Input type="checkbox"  onChange={handleChangeFieldLegalConsent}  name="FieldLegalConsent"  checked={FieldLegalConsent} invalid={NotValid && !FieldLegalConsent} />
                                            &nbsp;{i18n.t("finalText02")}
                                        </Label>
                                    </div>
                                    { !stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                    { stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                </div>
                            </Form>

                            <span className={"text-danger"}>* </span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default Remark

